import { Product } from '.';

export class Package {
    countries: string[];
    productsDetails: Product[];
}
